<template>
	<div class="media-wrapper">
		<media-block 
			v-for="(block, index) in data" 
			:key="'media' + index" 
			:data="block" 
			:columnClasses="columnClasses" 
			:isReady="ready" 
			v-on:heightChange="heightChange"></media-block>
	</div>
</template>

<script>
export default {
	component: 'media-content',
	props: ['data', 'columns', 'ready'],
	computed: {
		columnClasses() {
			if (this.columns=='1') {
				return {
					default: 'column small-12 medium-8 medium-offset-2',
					wide: 'column small-12 medium-10 medium-offset-1'
				}
			} else {
				return {
					default: 'column small-12',
					wide: 'column small-12',
				}
			}
		}
	},
	methods: {
		heightChange() {
			this.$emit('heightChange')
		}
	},
	components: {
		MediaBlock: () => import('./Block')
	}
}
</script>

<style lang="scss">
	@import "../../../styles/scss/global/ui/card";
	@import "../../../styles/scss/component/media";
</style>